import React from "react";
import FAQ from "./FAQ";
import Hblog from "./Hblog";
import HeroNew from "./Hero/HeroNew";
import HEvents from "./HEvents";
import styled from "styled-components";
import HIntro from "./HIntro";
import Footer from "components/Footer/Footer";
import ScrollToTopH from "components/ScrollToTopH";
import WellbeingDayHighlight from "./WellbeingDayHighlight/WellbeingDayHighlight";
import Wellbeing from "./Wellbeing/Wellbeing";

const HomeTag = styled.section`
  position: relative;
  margin-top: 8vh;
  min-height: 92vh;
  background: #fff;
`;
const Home = () => {
  return (
    <HomeTag>
      {/* <Hero/> */}
      {/* <WellbeingDayHighlight /> */}
      <HeroNew />
      {/* <HeroNewNew /> */}
      {/* <Intro3d/> */}
      <HIntro />
      <Wellbeing />
      <ScrollToTopH />
      <HEvents />
      <Hblog />
      <FAQ />
      {/* <Footer/> */}
      <Footer />
    </HomeTag>
  );
};

export default Home;
